// Offline Support (120): stale-data notice for read-only spectator pages.
//
// When the browser is offline, the service worker serves the last-cached API
// response (NetworkFirst). This banner makes that explicit so a spectator
// knows the scores/schedule may be behind. It refetches happen automatically
// once connectivity returns (the page's own effects re-run on focus/nav).

import { CloudOff } from "lucide-react";
import { useOnlineStatus } from "@/lib/offline/connectivity";

export function OfflineReadBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      className="flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900"
      data-offline-read-banner
    >
      <CloudOff className="h-4 w-4 shrink-0" aria-hidden />
      <span>You're offline. Showing the last data loaded on this device.</span>
    </div>
  );
}
